export enum TwoFactorAuthenticationType {
    temporarilyDisabledMfa = 'temporarilyDisabledMfa',
    verificationApp = 'verificationApp',
    verificationDevice = 'verificationDevice',
    withinMfaGracePeriod = 'withinMfaGracePeriod',
}
